var fontGroups = {
  ds_indigo: {
    'DSIndigo-Regular': {
      file: 'DSIndigo-Regular',
      family: 'DSIndigo',
      style: 'normal',
      weight: '400',
      extensions: ['woff2', 'woff']
    },
    'DSIndigo-Medium': {
      file: 'DSIndigo-Medium',
      family: 'DSIndigo',
      style: 'normal',
      weight: '500',
      extensions: ['woff2', 'woff']
    },
    'DSIndigo-Semibold': {
      file: 'DSIndigo-Semibold',
      family: 'DSIndigo',
      style: 'normal',
      weight: '600',
      extensions: ['woff2', 'woff']
    },
    'DSIndigo-Bold': {
      file: 'DSIndigo-Bold',
      family: 'DSIndigo',
      style: 'normal',
      weight: '700',
      extensions: ['woff2', 'woff']
    }
  },
  maven_pro: {
    maven_pro_regular: {
      file: 'maven_pro_regular',
      family: 'Maven Pro',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'otf', 'svg']
    },
    maven_pro_bold: {
      file: 'maven_pro_bold',
      family: 'Maven Pro',
      style: 'normal',
      weight: 'bold',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    }
  },
  salesforce_sans: {
    SalesforceSans_Regular: {
      file: 'SalesforceSans-Regular',
      family: 'Salesforce Sans',
      style: 'normal',
      weight: 'normal',
      extensions: ['woff', 'ttf']
    }
  },
  signature: {
    Docusign_1: {
      file: '1_Docusign',
      family: '1_Docusign',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Docusign_2: {
      file: '2_Docusign',
      family: '2_Docusign',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Docusign_3: {
      file: '3_Docusign',
      family: '3_Docusign',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Docusign_4: {
      file: '4_Docusign',
      family: '4_Docusign',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Docusign_5: {
      file: '5_Docusign',
      family: '5_Docusign',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Docusign_6: {
      file: '6_Docusign',
      family: '6_Docusign',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Docusign_7: {
      file: '7_Docusign',
      family: '7_Docusign',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Docusign_8: {
      file: '8_Docusign',
      family: '8_Docusign',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Mistral: {
      file: 'Mistral',
      family: 'Mistral',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    Rage: {
      file: 'Rage',
      family: 'Rage',
      style: 'normal',
      weight: 'normal',
      extensions: ['eot', 'woff', 'ttf', 'svg']
    },
    TA_akiko: {
      file: 'TA_akiko',
      family: 'TA_akiko',
      style: 'normal',
      weight: 'normal',
      extensions: ['ttf']
    },
    TA_asako: {
      file: 'TA_asako',
      family: 'TA_asako',
      style: 'normal',
      weight: 'normal',
      extensions: ['ttf']
    },
    TA_sourin_fude_02: {
      file: 'TA_sourin_fude_02',
      family: 'TA_sourin_fude_02',
      style: 'normal',
      weight: 'normal',
      extensions: ['ttf']
    },
    TA_yubi_hyojun_kaisyo: {
      file: 'TA_yubi_hyojun_kaisyo',
      family: 'TA_yubi_hyojun_kaisyo',
      style: 'normal',
      weight: 'normal',
      extensions: ['ttf']
    }
  }
};
export default fontGroups;